// Эмотивные темы для анализа текстов
export const EMOTIVE_THEMES = [
  { key: 'tgw_positive_emotions', label: 'Эмоции позитивные', description: 'Наличие в текстах позитивных эмоций (весело, красивый, любоваться, прелесть, радоваться)' },
  { key: 'tgw_negative_emotions', label: 'Эмоции негативные', description: 'Неприятные переживания, злость, ненависть, обида (возмущаться, зависть, ненавидеть)' },
  { key: 'tgw_bodily_states_emotions', label: 'Телесные состояния негативные', description: 'Лексика страдания, физических дискомфортов, мучений (агония, болеть, конвульсия)' },
  { key: 'tgw_motivation_activity', label: 'Активная деятельность', description: 'Стремление к активным действиям, изменениям (бурлить, волновать, грохот, мчаться)' },
  { key: 'tgw_destructive_activity', label: 'Деструктивная активность', description: 'Активность с негативными последствиями, разрушением (бойня, выгонять, долбануть, уничтожить)' },
];

// Темы по умолчанию (первые две)
export const DEFAULT_THEMES = [EMOTIVE_THEMES[0].key, EMOTIVE_THEMES[1].key];

// Словарь соответствий ключ темы -> метка
export const THEME_LABEL_BY_KEY = EMOTIVE_THEMES.reduce((acc, theme) => {
  acc[theme.key] = theme.label;
  return acc;
}, {});

